import 'typeface-roboto'
import React from 'react';
import ReactDOM from 'react-dom';
import { HashRouter } from 'react-router-dom'
import { Provider } from 'react-redux';
// import { BrowserRouter } from 'react-router-dom'

import App from './App';
// import * as serviceWorker from './serviceWorker';
import store from './store';

ReactDOM.render((
    <Provider store={store}>
        <HashRouter>
            <App />
        </HashRouter>
    </Provider>
), document.getElementById('root'));

// serviceWorker.register();

// serviceWorker.register({
//     onUpdate: (registration) => {
//         if (registration.waiting) {
//             registration.waiting.postMessage({ type: 'SKIP_WAITING' });
//             window.location.reload();
//         }
//     }
// });
// setInterval(() => {
//     if ('serviceWorker' in navigator) {
//         navigator.serviceWorker.getRegistration().then(reg => {
//             if (reg) reg.update();
//         });
//     }
// }, 3 * 60 * 1000);